var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Attachments',{staticClass:"residential-attachments",attrs:{"value":_vm.mergedAttachments}})
}
var staticRenderFns = []

export { render, staticRenderFns }